export default __webpack_public_path__ + "static/media/new-lead.152ec586.png";